<template>
  <div>
  <el-dialog title="Bond日志" :visible.sync="visible" width="900px" :close-on-click-modal="false">
    <div class="bond-no-info">当前查询Bond：{{ currentBondNo }}</div>
    <el-tabs v-model="activeTab">
      <el-tab-pane label="续保记录" name="renewal">
        <el-table :data="renewalRecords" border style="width: 100%">
          <el-table-column label="原到期日期" width="120">
            <template slot-scope="scope">{{ formatDate(scope.row.originalExpiryDate) }}</template>
          </el-table-column>
          <el-table-column label="更新后到期日期" width="130">
            <template slot-scope="scope">{{ formatDate(scope.row.newExpiryDate) }}</template>
          </el-table-column>
          <el-table-column prop="operator" label="操作人" width="100" />
          <el-table-column prop="operateTime" label="操作时间" width="160" />
          <el-table-column prop="renewalDesc" label="修订备注 (续保说明)" show-overflow-tooltip />
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="修订记录" name="revision">
        <el-table :data="revisionRecords" border style="width: 100%">
          <el-table-column prop="operateType" label="操作类型" width="100" />
          <el-table-column prop="operator" label="操作人" width="100" />
          <el-table-column prop="operateTime" label="操作时间" width="160" />
          <el-table-column prop="changeField" label="变更字段" width="140" />
          <el-table-column label="变更内容 (原值 -> 新值)" width="280">
            <template slot-scope="scope">
              <span 
                v-if="scope.row.operateType === '编辑修改'"
                class="change-content-link" 
                @click="showChangeDetail(scope.row.changeContent)"
              >{{ truncateContent(scope.row.changeContent) }}</span>
              <span v-else class="change-content-text">{{ scope.row.changeContent || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer">
      <el-button @click="handleClose">关闭</el-button>
    </span>

  </el-dialog>

  <!-- 变更详情弹窗（独立渲染到body，避免嵌套遮罩层叠加） -->
  <el-dialog 
    title="变更详情" 
    :visible.sync="detailVisible" 
    width="500px" 
    append-to-body
    :close-on-click-modal="false"
    custom-class="bond-change-detail-dialog"
  >
    <div class="change-detail-list">
      <div 
        v-for="(item, index) in changeDetailList" 
        :key="index" 
        class="change-detail-item"
      >
        <span class="field-name">{{ item.field }}</span>
        <span class="arrow">-></span>
        <span class="old-value">{{ item.oldValue }}</span>
        <span class="new-value">{{ item.newValue }}</span>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="detailVisible = false">关闭</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import { getBondLog } from '@/api/bondManagement'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'BondLogModal',
  data() {
    return {
      visible: false,
      bondUuid: '',
      currentBondNo: '',
      activeTab: 'renewal',
      renewalRecords: [],
      revisionRecords: [],
      detailVisible: false,
      changeDetailList: []
    }
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return ''
      return dateStr.substring(0, 10)
    },
    show(bondUuid, bondNo) {
      this.bondUuid = bondUuid
      this.currentBondNo = bondNo
      this.visible = true
      this.loadLog()
    },
    async loadLog() {
      const loading = getLoading4Cxt(this)
      try {
        const res = await getBondLog(this.bondUuid)
        const allLogs = res.data || []
        // 操作类型为"续保"的记录归类到续保记录
        this.renewalRecords = allLogs.filter(item => item.operateType === '续保')
        // 操作类型非"续保"的记录归类到修订记录
        this.revisionRecords = allLogs.filter(item => item.operateType !== '续保')
      } finally {
        loading.close()
      }
    },
    handleClose() {
      this.visible = false
    },
    truncateContent(content) {
      if (!content) return '-'
      if (content.length <= 30) return content
      return content.substring(0, 30) + '...'
    },
    showChangeDetail(content) {
      if (!content) return
      this.changeDetailList = content.split('\n').map(line => {
        const parts = line.split(': ')
        if (parts.length === 2) {
          const [field, value] = parts
          const arrowIndex = value.indexOf(' -> ')
          if (arrowIndex > -1) {
            return {
              field: field,
              oldValue: value.substring(0, arrowIndex),
              newValue: value.substring(arrowIndex + 4)
            }
          }
          return { field: field, oldValue: '', newValue: value }
        }
        return { field: '', oldValue: '', newValue: line }
      }).filter(item => item.field || item.newValue)
      this.detailVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.bond-no-info {
  margin-bottom: 15px;
  font-weight: bold;
  color: #333;
}

.change-content-link {
  color: #409EFF;
  cursor: pointer;
  text-decoration: underline;
}

.change-content-link:hover {
  color: #66b1ff;
}

.change-content-text {
  color: #333;
  word-break: break-all;
}

.change-detail-list {
  max-height: 400px;
  overflow-y: auto;
}

.change-detail-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.field-name {
  flex-shrink: 0;
  width: 120px;
  font-weight: bold;
  color: #333;
}

.arrow {
  flex-shrink: 0;
  margin: 0 10px;
  color: #999;
}

.old-value {
  flex-shrink: 0;
  width: 130px;
  color: #f56c6c;
  text-decoration: line-through;
}

.new-value {
  flex: 1;
  color: #67c23a;
}

</style>
